import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {emptyFn} from "presentation/common/helpers/utils";
import SignInMailIcon from "../sign-in-mail-icon";

import styles from './SignSuccessInfo.module.scss';

export const SignInSuccessInfo = (props) => {
  const {email, onResetSignIn} = props;

  return (
    <div className={clsx('flex flex-col justify-center items-center mt-5 pt-5', styles.formContainer)}>
      <h1><SignInMailIcon/></h1>
      <h3 className="mb-3 mt-4">Revise su correo electrónico</h3>
      <p> Hemos enviado a <span className={styles.underline}>{email}</span> un enlace para acceder. </p>
      <p className={styles.warning}>Si el correo no está en su bandeja de entrada verifique la carpeta SPAM.</p>
      <p className="mt-4 mb-1"> ¿Se ha equivocado? </p>
      <p className={clsx('flex justify-center btn-clear', styles.underline)} tabIndex="0" role="button"
         aria-pressed="false" onClick={onResetSignIn}>
        Vuelva a ingresar su correo electrónico
      </p>
    </div>
  );
};

SignInSuccessInfo.propTypes = {
  email: PropTypes.string,
  onResetSignIn: PropTypes.func
};

SignInSuccessInfo.defaultProps = {
  email: '',
  onResetSignIn: emptyFn
};

export default React.memo(SignInSuccessInfo);
